import { FC } from "react";
import useStyles from "../../../lead/quote/leadEstimateStyle";
import StorageContractForm from "./storageContractForm";

interface StorageContractProps {
  show: boolean;
  setShow: (show: boolean) => void;
  isReadOnly?: boolean;
}

const StorageContract: FC<StorageContractProps> = ({
  show,
  setShow,
  isReadOnly = false,
}) => {
  const classes = useStyles({ show });

  return (
    <>
      {show && (
        <section className={show ? classes.estimatePopupOverlay : ""}>
          <StorageContractForm
            show={show}
            setShow={setShow}
            screenType={"Storage Contract"}
            isReadOnly={isReadOnly}
          />
        </section>
      )}
    </>
  );
};

export default StorageContract;
